module.exports = __webpack_public_path__ + "static/image/logo-family/logo_taste@3x.png?3dc67b7c";